import { render, staticRenderFns } from "./BlogNoticia.vue?vue&type=template&id=02ae03a2&scoped=true"
import script from "./BlogNoticia.vue?vue&type=script&lang=js"
export * from "./BlogNoticia.vue?vue&type=script&lang=js"
import style0 from "./BlogNoticia.vue?vue&type=style&index=0&id=02ae03a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ae03a2",
  null
  
)

export default component.exports